import { render, staticRenderFns } from "./BuyoutBatchItemList.vue?vue&type=template&id=0f4c4b10&scoped=true"
import script from "./BuyoutBatchItemList.vue?vue&type=script&lang=js"
export * from "./BuyoutBatchItemList.vue?vue&type=script&lang=js"
import style0 from "./BuyoutBatchItemList.vue?vue&type=style&index=0&id=0f4c4b10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4c4b10",
  null
  
)

export default component.exports